import { AiFillDollarCircle, AiOutlineDollar, AiOutlineStop } from 'react-icons/ai';
import { FaQuestion } from 'react-icons/fa6';
import { IoCheckmarkCircleOutline, IoHourglassOutline } from 'react-icons/io5';

import { WithdrawalStatus } from '@ndvr/portfolio-api';

import { colors } from 'styles/theme/themeCore';

export const withdrawalStatusToIcon = (cashFlowType: WithdrawalStatus, selected?: boolean) => {
    switch (cashFlowType) {
        case WithdrawalStatus.UPCOMING:
            return <AiOutlineDollar size={22} color={selected ? colors.gold0 : colors.cocoa400} />;
        case WithdrawalStatus.IN_PROGRESS:
            return <IoHourglassOutline size={22} color={selected ? colors.gold0 : colors.cocoa800} />;
        case WithdrawalStatus.CASH_AVAILABLE:
            return <AiFillDollarCircle size={22} color={selected ? colors.gold0 : colors.green500} />;
        case WithdrawalStatus.COMPLETED:
            return <IoCheckmarkCircleOutline size={22} color={selected ? colors.gold0 : colors.green500} />;
        case WithdrawalStatus.CANCELED:
            return <AiOutlineStop size={22} color={selected ? colors.gold0 : colors.red400} />;
        default:
            return <FaQuestion size={22} color={selected ? colors.gold0 : colors.cocoa800} />;
    }
};
